import { apiSlice } from '../../api/apiSlice';

export const pdfGeneratorApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    pdfGenerator: builder.mutation({
      query: (option) => ({
        url: 'PdfGenerator',
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: option,
        responseHandler: (response) => response.blob()
      })
    })
  })
});

export const {
  usePdfGeneratorMutation
} = pdfGeneratorApi;